(function ($, Cobalt, undefined) {
    var isInitialized = false;

    Cobalt.Expandable = {

        initialize: function () {

            if (isInitialized) {
                return;
            }
            isInitialized = true;
            var cookieName = 'Navigation';
            var toggleSpeed = 200;
            var expandedClass = 'expanded';

            // Bind sections to toggle
            $('#navigation.expandable .section > span').click(function () {
                $(this).parent().toggleClass(expandedClass);
                $(this).siblings('ul').toggle(toggleSpeed);
                var navStr = '';
                $(this).parents('#navigation').find('.' + expandedClass).each(function () {
                    navStr += '#' + $(this).attr('id') + ',';
                });
                $.cookie(cookieName, navStr, { path: '/' });
            });

            // Set default expanded items from cookie
            if ($.cookie(cookieName)) {
                var expandedMenus = $.cookie(cookieName).split(',');
                $.each(expandedMenus, function (index, value) {
                    if (value) {
                        $(value).toggleClass(expandedClass);
                        $(value).find('ul').toggle();
                    }
                });
            }

            // Open up any submenu with an active subelement
            $('#navigation.expandable .section .selected').each(function () {
                $(this).parent().show();
                $(this).parents('.section').addClass(expandedClass);
            });
        }

    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Expandable.js